import { render, staticRenderFns } from "./three-step.vue?vue&type=template&id=c8695504&scoped=true"
import script from "./three-step.vue?vue&type=script&lang=js"
export * from "./three-step.vue?vue&type=script&lang=js"
import style0 from "./three-step.vue?vue&type=style&index=0&id=c8695504&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8695504",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8695504')) {
      api.createRecord('c8695504', component.options)
    } else {
      api.reload('c8695504', component.options)
    }
    module.hot.accept("./three-step.vue?vue&type=template&id=c8695504&scoped=true", function () {
      api.rerender('c8695504', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/complaintreporting/offline/components/three-step.vue"
export default component.exports